import psHttp, { psHttp$ } from '@patsnap/common-ps-http';
import { coreBasicApiUrlPrefix, insightsApiUrlPrefix, coreSearchApiUrlPrefix, paperResultApiUrlPrefix } from '../../config/constants';

export function getReexamApi (id) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${id}/reexamInvalid`,
        method: 'GET',
        transformCode: true
    });
}

export function downloadLegalFileApi (id, data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${id}/downloadLegalFile`,
        method: 'POST',
        data,
        transformCode: true
    });
}

export function getFileWrapperApi ({ patentId, rows, page, filter }) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/fileWrapper?rows=${rows}&page=${page}&filter=${filter}`,
        method: 'GET',
        transformCode: true
    });
}
export function getFileWrapperRejectionApi ({ patentId }) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/fileWrapper/rejection`,
        method: 'GET',
        transformCode: true,
        cache: true,
    });
}

export function getFileWrapperIdsApi ({ patentId }) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/fileWrapper/ids`,
        method: 'GET',
        transformCode: true,
        cache: true,
    });
}

export function getIdsSearchQueryApi ({ patentId, shortId }) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/fileWrapper/ids/search-query?short_id=${shortId}`,
        method: 'GET',
        transformCode: true
    });
}
export function getFileWrapperTdApi ({ patentId }) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/fileWrapper/td`,
        method: 'GET',
        transformCode: true,
        cache: true,
    });
}

export function getFileWrapperSummaryApi ({ patentId }) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/fileWrapper/summary`,
        method: 'GET',
        transformCode: true
    });
}

// 创建报告-US 审查员
export const createExaminer = (param) => {
    return psHttp({
        url: `${insightsApiUrlPrefix}/dashboard/examiner`,
        method: 'POST',
        data: param,
    });
};

// 创建公司报告
export const createCompanyReport = (param) => {
    return psHttp({
        url: `${insightsApiUrlPrefix}/dashboard/company`,
        method: 'POST',
        data: param,
    });
};

export function getSimilarPatentsApi (patentId) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/mlt`,
        method: 'GET',
        transformCode: true
    });
}

export function getFullImagesApi ({ type = 'srp', limit, page = 1, patentId, count, workspace_id, folder_id }) {
    const params = {
        type,
        limit,
        page,
        patentId,
        // 以下属性lab图片注释需要用到
        workspace_id,
        folder_id
    };
    if (type === 'view' && count) {
        params.patent_image_count = count;
    }
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/view/get_full_images`,
        method: 'GET',
        params,
        transformCode: true
    });
}

export function getLegalStatusApi (patentId) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/legal`,
        method: 'GET',
        transformCode: true
    });
}

export function getLegalCustomsApi (patentId) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/customs`,
        method: 'GET',
        transformCode: true
    });
}

export function getLitigationJsonApi ({ patentId, rows, page }) {
    const url = `${coreSearchApiUrlPrefix}/patent/id/${patentId}/litigation?rows=${rows}&page=${page}`;
    return psHttp({
        url,
        method: 'GET',
        transformCode: true,
        uuid: url,
        cache: true
    });
}

export function getLitigationFullTextApi(caseId) {
    const url = `${coreSearchApiUrlPrefix}/patent/view/caseId/${caseId}/full-text`;
    return psHttp({
        url,
        method: 'GET',
        uuid: url,
        cache: true
    });
}

export function getCaseApi(caseId) {
    const url = `${coreSearchApiUrlPrefix}/patent/view/case?case_id=${caseId}`;
    return psHttp({
        url,
        method: 'GET',
        uuid: url,
        cache: true
    });
}

export function getCaseBasicApi(caseId) {
    const url = `${coreSearchApiUrlPrefix}/litigation/view/case/basic?case_id=${caseId}`;
    return psHttp({
        url,
        method: 'GET',
        uuid: url,
        cache: true,
        headers: {
            'X-API-Version': '1.0',
        },
    });
}
export function getCaseDetailApi(caseId) {
    const url = `${coreSearchApiUrlPrefix}/litigation/view/case/detail?case_id=${caseId}`;
    return psHttp({
        url,
        method: 'GET',
        uuid: url,
        cache: true,
        headers: {
            'X-API-Version': '1.0',
        },
    });
}

export function getCasePatentApi(caseId) {
    const url = `${coreSearchApiUrlPrefix}/litigation/view/case/related-patents?case_id=${caseId}`;
    return psHttp({
        url,
        method: 'GET',
        uuid: url,
        cache: true,
        headers: {
            'X-API-Version': '1.0',
        },
    });
}

export function getFileWrapperDownloadLimitationApi (patentId, params = {}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/fileWrapper/limitation`,
        method: 'GET',
        params,
        transformCode: true
    }).then(({ data }) => {
        return data || {};
    });
}

export function fileWrapperDownloadApi (patentId, data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/fileWrapper/download`,
        method: 'POST',
        data,
        transformCode: true
    }).then(({ data }) => {
        return data || {};
    });
}

export function fileWrapperEmailApi (patentId, data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/fileWrapper/email`,
        method: 'POST',
        data,
        transformCode: true
    }).then(({ data }) => {
        return data || {};
    });
}

export function fileWrapperCnDownloadApi (patentId, data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/fileWrapperCn/download`,
        method: 'POST',
        data,
        responseType: 'blob',
        transformCode: false
    });
}

export function fileWrapperEpDownloadApi (patentId, data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/fileWrapperEp/download`,
        method: 'POST',
        data,
        responseType: 'blob',
        transformCode: false
    });
}

export function fileWrapperEpPreviewApi (patentId, data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/fileWrapperEp/preview`,
        method: 'POST',
        data,
        responseType: 'blob',
        transformCode: false
    });
}

export function getClmsTreeApi (patentId) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/clms-tree`,
        method: 'GET',
    });
}

export function getAllImagesByPatentIdApi (patentId) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/official-image`,
        method: 'GET',
    });
}

export function getClmsJsonApi ({ patentId, pn, data, compareRelatedId, textLang, params }) {
    return psHttp({
        cache: true,
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/clms`,
        method: 'POST',
        data: {
            include_patent_image: true,
            pn,
            compare_related_id: compareRelatedId,
            text_lang: textLang,
            ...data
        },
        params
    });
}

export function getCompareWithListApi ({ patentId, type, lang }) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/compare-with-list/${type}?lang=${lang}`,
        method: 'GET'
    });
}

export function getDescJsonApi ({ patentId, data, params, compareRelatedId, textLang }) {
    const url = `${coreSearchApiUrlPrefix}/patent/id/${patentId}/desc`;
    return psHttp$({
        cache: true,
        url,
        method: 'POST',
        uuid: `${url}_${JSON.stringify(data || {})}_${compareRelatedId || ''}`,
        data: {
            include_patent_image: true,
            compare_related_id: compareRelatedId,
            text_lang: textLang,
            ...data
        },
        params
    });

}

export function getPureTextApi ({ patentId, type, lang }) {
    return psHttp$({
        cache: true,
        uuid: `compare_pure_text${patentId}_${type}`,
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/text/${type}`,
        method: 'GET',
        params: {
            lang
        }
    });
}

export function getRevokedClaimTextApi ({ patentId, caseId }) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/revoked-claim/case_id/${caseId}/text`,
        method: 'GET',
        cache: true,
        transformCode: true
    }).then(({ data }) => {
        return data.data;
    });
}

export function getFamilyListApi (patentId, type, page) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/family-list`,
        method: 'GET',
        cache: true,
        params: { type, page }
    });
}

export function getFamilyJsonApi (patentId, type, page, authorities) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/family?type=${type}&page=${page}`,
        method: 'POST',
        cache: true,
        data: { authorities }
    });
}

export function getFamilyDatabaseApi (patentId, type) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/database`,
        method: 'POST',
        cache: true,
        data: { type }
    });
}

export function getFamilyTreeApi (patentId, type, data, cancelSource) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/family-tree?type=${type}`,
        method: 'POST',
        cancelToken: cancelSource.token,
        data
    });
}

export function getFamilyCountApi (patentId) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/family-count`,
        method: 'GET'
    });
}

export function errorReportApi(url, type, content) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/view/error-report`,
        uuid: url,
        data: {
            url,
            type,
            content
        },
        method: 'POST',
        cache: false
    });
}

export function getPdfDataApi(patentId) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/pdf`,
        method: 'GET'
    });
}

export function markApi(patentId) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/mark`,
        method: 'POST',
        data: {
            patentIds: [patentId],
            type: 'read'
        },
    });
}

export function hasFigurePartsApi(patentId, params) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/parts`,
        params,
        method: 'GET'
    });
}

export function getFiguresApi(patentId, imageUrl, box, data) {
    return psHttp({
        uuid: `getFigures_${patentId}_${imageUrl}_${JSON.stringify(box)}`,
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/figure`,
        responseType: 'text',
        transformResponse: [data => data],
        method: 'post',
        data
    });
}

export function downloadCaseFileApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/view/download_case`,
        method: 'POST',
        data,
        transformCode: true
    });
}

export function getCnFileWrapperApi(patentId, params) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/fileWrapperCn`,
        method: 'GET',
        params,
        transformCode: true
    });
}

export function getCnFileWrapperDetailApi(patentId, data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/fileWrapperCn/detail`,
        method: 'POST',
        data
    });
}

export function getEpFileWrapperApi(patentId) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/fileWrapperEp`,
        method: 'GET',
        transformCode: true
    });
}

export function getEpFileWrapperDetailApi(patentId, data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/fileWrapperEp/detail`,
        method: 'POST',
        data,
        transformCode: true
    });
}

export function getRelatedLiteratureApi(patentId, params) {
    return psHttp({
        url: `${paperResultApiUrlPrefix}/patent/id/${patentId}/related-paper`,
        method: 'GET',
        params,
        headers: { 'X-API-Version': '2.0' }
    });
}

export function getBasicByIdApi(patentId, params, data) {
    return psHttp$({
        cache: true,
        uuid: `basic_${patentId}_${JSON.stringify(params || {})}_${JSON.stringify(data || {})}`,
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/basic`,
        method: 'POST',
        data,
        params
    });
}

export function getBasicByIdWithoutHighlightApi(patentId) {
    return psHttp$({
        cache: true,
        uuid: `basic_${patentId}_highlight=false`,
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/basic`,
        method: 'POST',
        data: {}
    });
}

export function getCiteApi(patentId, family, page = 1, pageSize = 20) {
    const url = `${coreSearchApiUrlPrefix}/patent/id/${patentId}/cite?page=${page}&rows=${pageSize}&family_type=${family}`;
    return psHttp({
        cache: true,
        uuid: url,
        method: 'GET',
        url
    });
}

export function getCitedApi(patentId, family, page = 1, pageSize = 20) {
    const url = `${coreSearchApiUrlPrefix}/patent/id/${patentId}/cited?page=${page}&rows=${pageSize}&family_type=${family}`;
    return psHttp({
        cache: true,
        uuid: url,
        method: 'GET',
        url
    });
}

export function getPledgeJsonApi ({ patentId, rows, page }) {
    const url = `${coreSearchApiUrlPrefix}/patent/id/${patentId}/pledge?rows=${rows}&page=${page}`;
    return psHttp({
        url,
        uuid: url,
        cache: true,
        method: 'GET'
    });
}

export function getLicensingJsonApi ({ patentId, rows, page }) {
    const url = `${coreSearchApiUrlPrefix}/patent/id/${patentId}/licensing?rows=${rows}&page=${page}`;
    return psHttp({
        url,
        uuid: url,
        cache: true,
        method: 'GET'
    });
}

/* view init */
export function patentViewInitApi(params) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/view/init`,
        params,
        method: 'GET',
        headers: { 'X-API-Version': '2.0' }
    });
}

/* view init tab */
export function patentViewInitTabApi(patentId) {
    return psHttp$({
        url: `${coreSearchApiUrlPrefix}/patent/view/init-tab`,
        uuid: `req_initTab_${patentId}`,
        params: {
            patent_id: patentId
        },
        method: 'GET',
        cache: true
    });
}

export function getTimezoneApi() {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/view/time-zone/setting`,
        method: 'GET',
    });
}

/* view citation 跳转srp获取query_id */
export function getCiteSearchQueryApi({ type, patentId, family_type, short_id }) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/${type}/search-query`,
        params: {
            family_type,
            short_id
        },
        method: 'GET',
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function getAuthorityCheckApi(patentId) {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/patent/id/${patentId}/authority/check`,
        method: 'GET',
        transformCode: true
    }).then(({ data }) => {
        return data.data;
    });
}

export function getIndustrialInfoApi(ancsId) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/industrial/info/ancs_id/${ancsId}`,
        method: 'GET',
        transformCode: true
    }).then(({ data }) => {
        return data.data;
    });
}

export function getFamilyCondensedListApi({
    patentId,
    type,
    page,
    sort_type,
    sort_order,
}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/condensed-family-list`,
        method: 'GET',
        cache: true,
        params: {
            type,
            page,
            sort_type,
            sort_order,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data;
    });
}

export function getValuationApi(patentId) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/valuation`,
        method: 'GET',
        transformCode: true
    }).then(({ data }) => {
        return data.data;
    });
}

export function getFileWrapperClaimModifyApi({
    patentId, pfwId
}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/claim-modify/pwf_id/${pfwId}`,
        method: 'GET',
        cache: true,
        transformCode: true
    }).then(({ data }) => {
        return data.data;
    });
}

export function getFileWrapperOaResponseApi({
    patentId, apno
}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/id/${patentId}/oa_response`,
        method: 'GET',
        params: {
            apno
        },
        cache: true,
        transformCode: true
    }).then(({ data }) => {
        return data.data;
    });
}
